import { warehouseHolidayApis } from '@apis/dashboard/warehouseHolidayApis';
import { useMutation } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';

export const useDeleteWarehouseHoliday = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (id: number) => {
      const response = await warehouseHolidayApis.delete('/dashboard/warehouse-holiday/{id}', {
        path: {
          id,
        },
      });
      return response[204]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/warehouse-holiday/`]);
      },
    },
  );
};
